"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _prismicConfiguration = require("../prismic-configuration");
var _inspirationsLanding = _interopRequireDefault(require("@deosite/helpers/prismicDataMapper/inspirationsLanding"));
var _cache = require("@deosite/helpers/cache");
var _prismicHelper = require("../prismicHelper");
var _prismicErrorHandle = _interopRequireDefault(require("@deosite/helpers/prismicErrorHandle"));
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(uid, language) {
    var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, response, mappedInspirationsLanding, _yield$getLanguage2, _cacheFileExist, _cachedRequest;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: uid
            });
          case 2:
            _yield$getLanguage = _context2.sent;
            cacheFileExist = _yield$getLanguage.cacheFileExist;
            cachedRequest = _yield$getLanguage.cachedRequest;
            lang = _yield$getLanguage.lang;
            cacheFilePath = _yield$getLanguage.cacheFilePath;
            if (!cacheFileExist) {
              _context2.next = 9;
              break;
            }
            return _context2.abrupt("return", cachedRequest);
          case 9:
            _context2.prev = 9;
            _context2.next = 12;
            return (0, _prismicHelper.getResponsePrismicByUID)({
              type: "inspirationslanding",
              uid: uid,
              lang: lang
            });
          case 12:
            response = _context2.sent;
            _context2.t0 = response === null || response === void 0 ? void 0 : response.data;
            if (!_context2.t0) {
              _context2.next = 17;
              break;
            }
            _context2.next = 17;
            return Promise.all(response.data.body.map(/*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(element) {
                var _element$primary$blog;
                return _regenerator["default"].wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        if (!(element.slice_type === "banner" && (_element$primary$blog = element.primary.blogger) !== null && _element$primary$blog !== void 0 && _element$primary$blog.id)) {
                          _context.next = 5;
                          break;
                        }
                        _context.next = 4;
                        return (0, _prismicConfiguration.Client)().getByID(element.primary.blogger.id);
                      case 4:
                        element.bloggerData = _context.sent;
                      case 5:
                        _context.next = 10;
                        break;
                      case 7:
                        _context.prev = 7;
                        _context.t0 = _context["catch"](0);
                        throw _context.t0;
                      case 10:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 7]]);
              }));
              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));
          case 17:
            mappedInspirationsLanding = (0, _inspirationsLanding["default"])(response.data);
            _context2.next = 20;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: "".concat(uid, ".json"),
              result: mappedInspirationsLanding
            });
          case 20:
            return _context2.abrupt("return", mappedInspirationsLanding);
          case 23:
            _context2.prev = 23;
            _context2.t1 = _context2["catch"](9);
            _context2.next = 27;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: uid
            });
          case 27:
            _yield$getLanguage2 = _context2.sent;
            _cacheFileExist = _yield$getLanguage2.cacheFileExist;
            _cachedRequest = _yield$getLanguage2.cachedRequest;
            if (!_cacheFileExist) {
              _context2.next = 32;
              break;
            }
            return _context2.abrupt("return", _cachedRequest);
          case 32:
            return _context2.abrupt("return", (0, _prismicErrorHandle["default"])(_context2.t1, "Prismic - inspirations landing"));
          case 33:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[9, 23]]);
  }));
  return function fetcher(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;